export function modalCampusCreate(setElement) {
  const uri = new URL(window.location.href);
  let campusImg01;
  let campusImg01Url;
  let campusImg02;
  let campusImg02Url;
  let modalContent;

  const campusText = setElement.dataset.campustext;
  const campusLink = setElement.dataset.campuslink || '';
  const campusLabel = setElement.querySelector('.js-modalCampusLabel').textContent;
  const campusName = setElement.querySelector('.js-modalCampusName').textContent;

  // モーダル内に設置する要素の生成
  const modalCreate = document.createElement('div');
  modalCreate.className = 'c-modal_box';

  if (setElement.dataset.campusimg01) {
    // 1枚目の写真が存在する
    campusImg01 = setElement.dataset.campusimg01;
    campusImg01Url = uri.origin + '/wp-content/themes/otemae/assets/img/about/campus/' + campusImg01;

    // 2枚目の写真判定
    if (setElement.dataset.campusimg02) {
      // 2枚目の写真が存在する
      campusImg02 = setElement.dataset.campusimg02;
      campusImg02Url = uri.origin + '/wp-content/themes/otemae/assets/img/about/campus/' + campusImg02;

      modalContent = `<div class="p-campusModal js-modalCampusInner">
        <p class="c-headingSize24 c-headingLine p-campusModal_heading u-fw--500 u-ff--shipporiMincho">
          <span class="p-campusModal_headingLabel c-textSize14 u-clrBg--blueLight js-modalCampusInnerLabel">${campusLabel}</span>
          <span class="p-campusModal_headingName js-modalCampusInnerName">${campusName}</span>
        </p>
        <p class="c-textSize15 p-campusModal_text js-modalCampusInnerText">${campusText}</p>
        <div class="p-campusModal_img js-modalCampusInnerImgCont">
          <div class="p-campusModal_imgBox">
            <img src="${campusImg01Url}" class="js-modalCampusInnerImg01" alt="">
          </div>
          <div class="p-campusModal_imgBox">
            <img src="${campusImg02Url}" class="js-modalCampusInnerImg02" alt="">
          </div>
        </div>
      </div>`;
    } else {
      // 2枚目の写真が存在しない
      modalContent = `<div class="p-campusModal js-modalCampusInner">
        <p class="c-headingSize24 c-headingLine p-campusModal_heading u-fw--500 u-ff--shipporiMincho">
          <span class="p-campusModal_headingLabel c-textSize14 u-clrBg--blueLight js-modalCampusInnerLabel">${campusLabel}</span>
          <span class="p-campusModal_headingName js-modalCampusInnerName">${campusName}</span>
        </p>
        <p class="c-textSize15 p-campusModal_text js-modalCampusInnerText">${campusText}</p>
        <div class="p-campusModal_img js-modalCampusInnerImgCont">
          <div class="p-campusModal_imgBox">
            <img src="${campusImg01Url}" class="js-modalCampusInnerImg01" alt="">
          </div>
        </div>
      </div>`;
    }
  } else {
    // 1枚目の写真が存在しない
    modalContent = `<div class="p-campusModal js-modalCampusInner">
      <p class="c-headingSize24 c-headingLine p-campusModal_heading u-fw--500 u-ff--shipporiMincho">
        <span class="p-campusModal_headingLabel c-textSize14 u-clrBg--blueLight js-modalCampusInnerLabel">${campusLabel}</span>
        <span class="p-campusModal_headingName js-modalCampusInnerName">${campusName}</span>
      </p>
      <p class="c-textSize15 p-campusModal_text js-modalCampusInnerText">${campusText}</p>
    </div>`;
  }

  if (campusLink) {
    const btnCreate = `
      <div class="p-campusModal_btn js-modalCampusBtn">
        <a href="${campusLink}" class="c-btnArrowBefore" rel="noopener">
          <span class="c-btnArrowBefore_item u-clrBg--grayPale"></span>
          <span class="c-btnArrowBefore_text c-textSize16">${campusName}</span>
        </a>
      </div>`;
    modalContent += btnCreate;
  }

  modalContent += `</div>`;
  modalCreate.innerHTML = modalContent;

  return modalCreate;
}

export function modalCampusUpdate(setElement) {
  const thisModalLabel = document.querySelector('.js-modalCampusInnerLabel');
  const thisModalName = document.querySelector('.js-modalCampusInnerName');
  const thisModalText = document.querySelector('.js-modalCampusInnerText');
  let thisModalImg01;
  let thisModalImg02;
  let thismodalCampusInner;
  let thisModalCont;

  const thisModalBtn = document.querySelector('.js-modalCampusBtn');
  const thisModalBox = document.querySelector('.p-campusModal');

  const campusLabel = setElement.querySelector('.js-modalCampusLabel').textContent;
  const campusName = setElement.querySelector('.js-modalCampusName').textContent;
  const campusText = setElement.dataset.campustext;
  const uri = new URL(window.location.href);
  const campusLink = setElement.dataset.campuslink || '';

  thisModalLabel.innerText = campusLabel;
  thisModalName.innerText = campusName;
  thisModalText.innerText = campusText;

  // 1枚目の写真判定
  if (document.querySelector('.js-modalCampusInnerImg01')) {
    // 1枚目の写真要素を取得
    thisModalImg01 = document.querySelector('.js-modalCampusInnerImg01');

    // 現在表示されているモーダルの次に表示するモーダルで1枚目の写真を設定するdata属性が存在するか判定
    if (setElement.dataset.campusimg01) {
      // 1枚目の写真を設定するdata属性が存在する場合はdata属性を取得してセット
      const campusImg01 = setElement.dataset.campusimg01;
      const campusImg01Url = uri.origin + '/wp-content/themes/otemae/assets/img/about/campus/' + campusImg01;
      thisModalImg01.setAttribute('src', campusImg01Url);
    } else {
      //  1枚目の写真を設定するdata属性が存在しない場合は2枚目の写真をwrapしていたdivを削除
      thisModalImg01.parentNode.remove();
    }
  } else {
    // 現在生成されているモーダルに1枚目の写真が存在せず、次に表示するモーダルには1枚目の写真が存在する場合
    if (setElement.dataset.campusimg01) {
      // 1枚目の写真を設定するdata属性が存在する場合はdata属性を取得してセット
      const campusImg01 = setElement.dataset.campusimg01;
      const campusImg01Url = uri.origin + '/wp-content/themes/otemae/assets/img/about/campus/' + campusImg01;

      // 写真を追加するモーダル要素を取得
      thismodalCampusInner = document.querySelector('.js-modalCampusInner');

      // 1枚目の写真を表示させる為のdivを生成
      if (document.querySelector('.js-modalCampusInnerImgCont')) {
        thisModalCont = document.querySelector('.js-modalCampusInnerImgCont');
      } else {
        const divImg = document.createElement('div');
        divImg.className = 'p-campusModal_img';
        divImg.classList.add('js-modalCampusInnerImgCont');
        thismodalCampusInner.appendChild(divImg);

        thisModalCont = document.querySelector('.js-modalCampusInnerImgCont');
      }

      const divImg01 = document.createElement('div');
      divImg01.className = 'p-campusModal_imgBox';
      const addImg01 = `<img src="${campusImg01Url}" class="js-modalCampusInnerImg01" alt="">`;
      divImg01.innerHTML = addImg01;

      thisModalCont.appendChild(divImg01);
    }
  }

  // 2枚目の写真判定
  if (document.querySelector('.js-modalCampusInnerImg02')) {
    // 現在生成されているモーダルに2枚目の写真が存在している
    // 2枚目の写真要素を取得
    thisModalImg02 = document.querySelector('.js-modalCampusInnerImg02');

    // 現在表示されているモーダルの次に表示するモーダルで2枚目の写真を設定するdata属性が存在するか判定
    if (setElement.dataset.campusimg02) {
      // 2枚目の写真を設定するdata属性が存在する場合はdata属性を取得してセット
      const campusImg02 = setElement.dataset.campusimg02;
      const campusImg02Url = uri.origin + '/wp-content/themes/otemae/assets/img/about/campus/' + campusImg02;
      thisModalImg02.setAttribute('src', campusImg02Url);
    } else {
      //  2枚目の写真を設定するdata属性が存在しない場合は2枚目の写真をwrapしていたdivを削除
      thisModalImg02.parentNode.remove();
    }
  } else {
    // 現在生成されているモーダルに2枚目の写真が存在せず、次に表示するモーダルには2枚目の写真が存在する場合
    if (setElement.dataset.campusimg02) {
      // 2枚目の写真を設定するdata属性が存在する場合はdata属性を取得してセット
      const campusImg02 = setElement.dataset.campusimg02;
      const campusImg02Url = uri.origin + '/wp-content/themes/otemae/assets/img/about/campus/' + campusImg02;

      // 2枚目の写真を表示させる為のdivを生成
      thisModalCont = document.querySelector('.js-modalCampusInnerImgCont');

      const divImg02 = document.createElement('div');
      divImg02.className = 'p-campusModal_imgBox';
      const addImg02 = `<img src="${campusImg02Url}" class="js-modalCampusInnerImg02" alt="">`;
      divImg02.innerHTML = addImg02;

      thisModalCont.appendChild(divImg02);
    }
  }

  if (campusLink) {
    if (thisModalBtn) {
      const anchor = thisModalBtn.querySelector('.c-btnArrowBefore');
      anchor.href = campusLink;

      const text = thisModalBtn.querySelector('.c-btnArrowBefore_text');
      text.textContent = campusName;
    } else {
      const btnCreate = document.createElement('div');
      btnCreate.className = 'p-campusModal_btn js-modalCampusBtn';
      btnCreate.innerHTML = `
        <a href="${campusLink}" class="c-btnArrowBefore" rel="noopener">
          <span class="c-btnArrowBefore_item u-clrBg--grayPale"></span>
          <span class="c-btnArrowBefore_text c-textSize16">${campusName}</span>
        </a>`;
      thisModalBox.appendChild(btnCreate);
    }
  } else if (thisModalBtn) {
    thisModalBtn.remove();
  }
}
